import { useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';
import { ensurePushForUser } from '../utils/push';

/**
 * Seamless push on login: re-assert (or silently restore) this browser's push
 * subscription for the logged-in user. Handles the shared-device edge case
 * (ownership transfers to whoever logs in) and the everyday one (push stays on
 * across logouts and session expiries) — unless the user explicitly turned it
 * off on this device. Never prompts for permission.
 */
export const usePushOwnershipSync = () => {
  const { user } = useUserContext();
  const userId = (user as any)?.userId;

  useEffect(() => {
    if (!userId) return;
    ensurePushForUser(userId).catch(() => {
      // Best-effort — never disturb app startup
    });
  }, [userId]);
};
